import $http from "@/plugins/axios.js";

export default {
  state: {
    card: null,
    message: null,
    messageFaild: 0,
    isAlterCard: false,
    userCard: null,
    smartCard: null,
    exchangeState: null,
  },
  getters: {
    card: (state) => state.card,
    message: (state) => state.message,
    messageFaild: (state) => state.messageFaild,
    userCard: (state) => state.userCard,
    smartCard: (state) => state.smartCard,
    exchangeState: (state) => state.exchangeState,
  },
  mutations: {
    SET_CARD(state, data) {
      state.card = data;
    },
    SET_USER_CARD(state, data) {
      state.userCard = data;
    },
    SET_SMART_CARD(state, data) {
      state.smartCard = data;
    },
    SET_MESSAGE(state, data) {
      state.message = data;
    },
    SET_MESSAGE_FAILD(state, data) {
      state.messageFaild = data;
    },
    SET_EXCHANGE_STATE(state, data) {
      state.exchangeState = data;
    },
  },
  actions: {
    async getCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`store/cards/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", null);
        throw err;
      }
    },
    async getExchangeCard({ commit, dispatch }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.get(`store/cards/exchange/${id}`);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم استبدال الحساب بنجاح",
          duration: 6,
        });
        dispatch("toggleBtnLoading", false);
        commit("SET_EXCHANGE_STATE", res.data.success);
      } catch (err) {
        if (err.response.status === 401) {
          dispatch("pushAlert", {
            alertVariant: "warning",
            alertMessage:
              "الحساب يعمل ولا يحتاج الى الاستبدال, في حال وجود مشكلة تواصل معنا عبر الواتساب",
            duration: 6,
          });
        }
        dispatch("toggleIsLoading", false);
        commit("SET_EXCHANGE_STATE", err.response.data.success);
      }
    },
    async getUserCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`userwallet/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_USER_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_USER_CARD", null);
        throw err;
      }
    },

    async getSmartCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`account/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_SMART_CARD", null);
        throw err;
      }
    },

    async addUserData({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post(`/userwallet/usercard/${payload.id}`, {
          birthday: payload.birthday,
          email: payload.email,
          firstName: payload.firstName,
          lastName: payload.lastName,
          password: payload.password,
          phoneNumber: payload.phoneNumber,
        });
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },

    async addSmartData({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        const formData = new FormData();
        formData.append("birthday", payload.birthday || "");
        formData.append("email", payload.email || "");
        formData.append("firstName", payload.firstName || "");
        formData.append("lastName", payload.lastName || "");
        formData.append("password", payload.password || "");
        formData.append("phoneNumber", payload.phoneNumber || "");
        formData.append("notes", payload.notes || "");
        formData.append("facebook", payload.facebook || "");
        formData.append("instagram", payload.instagram || "");
        formData.append("tiktok", payload.tiktok || "");
        formData.append("telegram", payload.telegram || "");
        formData.append("whatsapp", payload.whatsapp || "");
        formData.append("x", payload.x || "");
        formData.append("youtube", payload.youtube || "");
        formData.append("linkedin", payload.linkedin || "");
        formData.append("snapchat", payload.snapchat || "");
        formData.append("occupation", payload.occupation || "");
        formData.append("address", payload.address || "");
        formData.append("description", payload.description || "");

        if (payload.image) {
          formData.append("image", payload.image);
        }
        await $http.post(`/account/account/${payload.id}`, formData);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },

    async getAlterCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`store/gmail/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", null);
        throw err;
      }
    },
    setMessageFaild({ commit }, payload) {
      commit("SET_MESSAGE_FAILD", payload);
    },
    async getMessage({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.post("/email", payload);
        dispatch("toggleBtnLoading", false);
        commit("SET_MESSAGE", res.data.data);
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          if (localStorage.getItem("messageFaild")) {
            localStorage.setItem(
              "messageFaild",
              JSON.parse(localStorage.getItem("messageFaild")) + 1
            );
            commit(
              "SET_MESSAGE_FAILD",
              JSON.parse(localStorage.getItem("messageFaild"))
            );
          } else {
            localStorage.setItem("messageFaild", 0);
          }
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
  },
};
